// extracted by css-extract-rspack-plugin
export default {"grid":"_642fd6f5"};